import React, { ComponentProps } from 'react'
import { Field } from 'react-final-form'

import { FieldValidator } from 'final-form'
import { DateTime } from 'luxon'
import Utils from 'Utils'

import DateTimeInput from './DateTimeInput'

type Props = ComponentProps<typeof DateTimeInput> & {
  name: string
  checkErrorIfDirty?: boolean
  displayError?: boolean
  validate?: FieldValidator<DateTime>
}

function DateTimeInputField({
  checkErrorIfDirty,
  displayError = true,
  name,
  validate,
  ...rest
}: Props) {
  return (
    <Field<DateTime> name={name} validate={validate}>
      {({ input: { value, onChange: handleChange }, meta }) => {
        // @ts-expect-error
        const { hasError, error } = Utils.Form.hasError(meta, checkErrorIfDirty)

        return (
          <DateTimeInput
            {...rest}
            caption={displayError && error}
            danger={hasError}
            value={value}
            onChange={handleChange}
          />
        )
      }}
    </Field>
  )
}

export default DateTimeInputField
